import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaStatistics = React.lazy(() =>
    import('../NebulaStatistics')
);
const nebulaStatisticsRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_STATISTICS_PAGE,
        element: <NebulaStatistics />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaStatisticsRoutesRegistry;
